import SupplierShedWidgetContainer from "./SupplierShedWidgetContainer";
export type { SupplierShedApiResponse }  from "./SupplierShedWidgetContainer";

export default SupplierShedWidgetContainer;
